import httpclient from"./httpclient";export default{info:{key:"csharp",title:"CSharp",extname:".cs",default:"httpclient"},httpclient:httpclient};
//# sourceMappingURL=index.js.map